import React from 'react'
import ReactDOM from 'react-dom/client'
import LandingPage from '../LandingPage.tsx'
import './globals.css'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LandingPage />
  </React.StrictMode>,
)
